"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const decision_1 = require("./decision");
const index_1 = require("./index");
class DecisionList extends index_1.TopLevelNode {
    constructor(localId) {
        super();
        this.localId = localId;
        this.content = new index_1.ContentNode('decisionList');
    }
    decision(localId, state) {
        return this.content.add(new decision_1.Decision(localId, state));
    }
    toJSON() {
        return Object.assign({}, this.content.toJSON(), { attrs: {
                localId: this.localId
            } });
    }
}
exports.DecisionList = DecisionList;
//# sourceMappingURL=decision-list.js.map